import styles from "./stepper.module.css";

const Stepper = ({ steps, currentStep }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => (
        <div key={index} className={styles.stepItem}>
          <div
            className={`${styles.dot} ${
              index < currentStep
                ? styles.completed
                : index === currentStep
                ? styles.active
                : ""
            }`}
          >
            {index < currentStep ? "✓" : index + 1}
          </div>
          <span
            className={`${styles.label} ${
              index === currentStep ? styles.activeLabel : ""
            }`}
          >
            {step}
          </span>
          {index < steps.length - 1 && <div className={styles.line} />}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
